import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from './services/auth.service';
import { LoginComponent } from './components/login/login.component';
import { OpenRequestsComponent } from './open-requests/open-requests.component';
import { RouterOutlet } from '@angular/router';
import { NavComponent } from './components/nav/nav.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NavComponent, RouterOutlet, OpenRequestsComponent, LoginComponent]
})
export class AppComponent {

  constructor(
    private authService: AuthService
  ) {

  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }
}
